module.exports = __webpack_public_path__ + "img/1.b2d82ab8.jpg";